<template>
  <div id="app" class="app-container" v-loading="initLoading">
    <el-card class="header-card">
      <div class="header-content">
        <div v-if="logo" class="logo-col">
          <img class="logo" :src="logo" alt="Brand Logo">
        </div>
        <div class="title-col">
          <h1 class="page-title">{{ this.$store.state.texts.title }}</h1>
        </div>
      </div>
    </el-card>

    <div class="form-container">
      <div v-if="step === 'first'" class="step-content">
        <el-form :model="form" :rules="rules" ref="formStepFirst" label-position="top" class="warranty-form">
          <el-form-item label="Your Products" prop="product_id" class="form-item-card">
            <el-select v-model="form.product_id" placeholder="Please Select" @change="onProductChange" class="full-width-select">
              <el-option v-for="p in products" :key="p.id" :label="p.name" :value="p.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Email Address" prop="email" class="form-item-card">
            <el-input v-model="form.email" type="email"></el-input>
          </el-form-item>
          <el-form-item label="Amazon Order ID (ex:123-1234567-1234567)" class="form-item-card" prop="order_no">
            <el-input v-model="form.order_no" placeholder="123-1234567-1234567"></el-input>
          </el-form-item>
          <el-form-item label="Overall, how satisfied are you with the product?" class="form-item-card" prop="satisfied">
            <el-radio-group v-model="form.satisfied" @change="satisfiedChange" class="satisfaction-radio-group">
              <el-radio label="1">Satisfied</el-radio>
              <el-radio label="0">Dissatisfied</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="button-group">
            <el-button type="primary" @click="goNextStep()" class="action-button">Next</el-button>
          </div>
        </el-form>
      </div>

      <div v-else-if="step === 'gift'" class="step-content">
        <el-form :model="form" :rules="rules" ref="formStepGift" label-position="top" class="warranty-form">
          <el-form-item class="form-item-card" prop="gift_id">
            <p class="gift-description" v-html="texts.text_gift"></p>
              <el-radio-group v-model="form.gift_id" class="gift-radio-group">
              <el-row type="flex" :gutter="20" class="gift-row">
                <el-col v-for="{id, name, picture} in gifts[form.product_id]" :key="id" 
                        :xs="24" :sm="12" :md="12" :lg="12" class="gift-col">
                  <el-radio-button :label="id" class="gift-radio-button">
                    <div class="gift-item">
                      <el-image :src="picture" fit="cover" class="gift-image"></el-image>
                      <p class="gift-name">{{ name }}</p>
                    </div>
                  </el-radio-button>
                </el-col>
              </el-row>
            </el-radio-group>
          </el-form-item>
          <div class="button-group">
            <el-button type="default" @click="goPreviousStep()" class="action-button">Previous</el-button>
            <el-button type="primary" @click="goNextStep()" class="action-button">Next</el-button>
          </div>
        </el-form>
      </div>

      <div v-else-if="step === 'submit'" class="step-content">
        <el-form :model="form" :rules="rules" ref="formStepSubmit" label-position="top" v-loading="submitting" class="warranty-form">
          <el-form-item class="form-item-card" prop="s1">
            <div class="submit-description" v-html="texts.text_submit"></div>
          </el-form-item>
          <div class="button-group">
            <el-button type="default" @click="goPreviousStep()" class="action-button">Previous</el-button>
            <el-button type="primary" @click="submitForm('form')" class="action-button" :loading="submitting">Submit</el-button>
          </div>
        </el-form>
      </div>

      <div v-else-if="step === 'ok'" class="step-content">
        <div class="success-container">
          <img src="../public/success.png" alt="success" class="success-image">
          <div class="success-message" v-html="texts.text_success"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";

// const baseUrl = 'http://localhost:8000';
const baseUrl = '';

const rules = {
  product_id: [
    {required: true, message: 'please select your product', trigger: 'change'}
  ],
  email: [
    {required: true, message: '', trigger: 'blur', type: 'email'}
  ],
  satisfied: [
    {required: true, message: 'required'}
  ],
    gift_id: [
    {required: true, message: 'please tell us what you are interested in'}
  ]
}


const defaultsText = {
    'text_gift': 'As part of our warranty membership program, you have chance to get an exclusive FREE gift, please tell us what you are interested in',
    'text_submit': 'Please click the submit button, and we hope that if there is anything else we can do for you, please contact us anytime. Email:{email}',
    'text_success': 'Submit Successfully! we hope that if there is anything else we can do for you, please contact us anytime. Email:{email}',
}

export default {
  name: 'app',
  metaInfo: {
    title: "WarrantyServe",
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
      }
    ]
  },
  components: {},
  computed: {},
  data() {
    return {
      step: 'first',
      // step: 'gift',
      stepStack: [],
      submitting: false,
      form: {
        product_id: '',
        email: '',
        order_no: '',
        satisfied: '',
        gift_id: '',
        },
      products: [
        {"id": 1, "name": "apple 12 pro max 64G"},
        {"id": 2, "name": "apple 12 mini 64G"},
      ],
      gifts: {},
      input: "",
      rules: rules,
      stepForm: {
        'first': 'formStepFirst',
        'gift': 'formStepGift',
        'submit': 'formStepSubmit',
      },
      initLoading: true,
      texts: defaultsText,
      title: 'ACTIVATE EXTENDED WARRANTY NOW',
      logo: '',
    }
  },
  created() {
    this.initBrand()
    this.initProducts()
  },
  methods: {
    getBrand() {
      let href = window.location.href.split('/')
      let i = href.length
      let brand = ''
      while (i) {
        i--
        if (href[i]) {
          brand = href[i]
          break
        }
      }
      return brand
    },
    initProducts() {
      let brand = this.getBrand()
      axios.get(baseUrl + '/sheet/products?brand=' + brand).then((resp) => {
        console.log(JSON.stringify(resp))
        if (resp.data && resp.data.data) {
          this.products = resp.data.data
        }
      }).catch((error) => {
        alert(error)
      })
    },
    initBrand() {
      let brand = this.getBrand()
      axios.get(baseUrl + '/sheet/config?brand=' + brand).then((resp) => {
        console.log(JSON.stringify(resp))
        if (resp.data && resp.data.data) {
          this.texts = resp.data.data.text
          this.title = resp.data.data.title
          this.logo = resp.data.data.logo
          this.initLoading = false
        }
      }).catch((error) => {
        alert(error)
      })
    },
    onProductChange(val) {
      let product_id = this.form.product_id
      console.log(product_id, val)
      if (!(this.gifts[product_id] && this.gifts[product_id].length > 0)) {
        axios.get(baseUrl + '/sheet/gifts?product_id=' + product_id).then((resp) => {
          console.log(JSON.stringify(resp))
          if (resp.data && resp.data.data) {
            this.gifts[product_id] = resp.data.data
          }
        })
      }
    },
    submitForm() {
      this.submitting = true
      axios.post(baseUrl + '/sheet/submit', this.form).then((resp) => {
        console.log(resp)
      }).catch((err) => {
        console.log(err)
      }).then(() => {
        this.submitting = false
      })
      this.step = 'ok'
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    satisfiedChange(val) {
      let that = this
      if (val === '0') {
        that.form.gift_id = ''
      }
      // that.form.satisfied = val
    },
    goPreviousStep() {
      try {
        this.$refs[this.stepForm[this.step]].resetFields();
      } catch (e) {
        console.log(e)
      }
      this.step = this.stepStack.pop()
      if (!this.step) {
        this.step = 'first'
      }
    },
    goNextStep() {
      let currentPage = this.step
      let form = this.$refs[this.stepForm[this.step]]
      let onSuccess = () => {
        this.stepStack.push(currentPage)
      }
      if (currentPage === 'first') {
        form.validate((valid) => {
          if (valid) {
            if (this.form.satisfied === '1') {
              if (this.gifts[this.form.product_id] && this.gifts[this.form.product_id].length > 0) {
                this.step = 'gift'
              } else {
                this.step = 'submit'
              }
            } else {
              this.step = 'submit'
            }
            onSuccess()
          } else {
            return false;
          }
        });
      } else if (currentPage === 'gift') {
        form.validate((valid) => {
          if (valid) {
            this.step = 'submit'
            onSuccess()
          } else {
            return false;
          }
        });
      }
    }
  }
}
</script>

<style scoped>
/* Base Styles */
html {
  background-color: rgb(242, 242, 242);
}

.app-container {
  font-family: Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 320px;
  max-width: 100%;
  margin: 0 auto;
  padding: 10px;
  box-sizing: border-box;
}

/* Header Styles */
.header-card {
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  background-color: #fff;
}

.header-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.logo-col {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.title-col {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.logo {
  width: 90px;
  height: auto;
  max-width: 100%;
  object-fit: contain;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #2c3e50;
  line-height: 1.4;
}

/* Form Container */
.form-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.step-content {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.warranty-form {
  width: 100%;
}

/* Form Item Cards */
.form-item-card {
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e4e7ed;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.3s ease, border-color 0.3s ease;
}

.form-item-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #c0c4cc;
}

.form-item-card ::v-deep .el-form-item__label {
  padding-top: 0 !important;
  padding-bottom: 10px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  color: #303133 !important;
}

.form-item-card ::v-deep .el-form-item__content {
  font-size: 16px !important;
  line-height: 24px !important;
}

/* Input Styles */
.full-width-select {
  width: 100%;
}

.full-width-select ::v-deep .el-input__inner {
  height: 44px;
  font-size: 16px;
}

.form-item-card ::v-deep .el-input__inner {
  height: 44px;
  font-size: 16px;
  border-radius: 6px;
}

/* Radio Group Styles */
.satisfaction-radio-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.satisfaction-radio-group ::v-deep .el-radio {
  margin-right: 0;
  margin-bottom: 0;
  line-height: 32px;
}

.satisfaction-radio-group ::v-deep .el-radio__label {
  font-size: 16px;
  padding-left: 8px;
}

/* Gift Selection Styles */
.gift-description {
  margin: 0 0 20px 0;
  font-size: 16px;
  line-height: 1.6;
  color: #606266;
}

.gift-radio-group {
  width: 100%;
}

.gift-row {
  margin: 0 !important;
  flex-wrap: wrap; /* critical: keep 2-per-row stable under flex layout */
  align-items: stretch;
}

.gift-col {
  margin-bottom: 16px;
  display: flex; /* let the radio button stretch to full column height */
}

.gift-radio-button {
  width: 100%;
  height: 100%;
  display: flex;
}

.gift-radio-button ::v-deep .el-radio-button__inner {
  width: 100%;
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #e4e7ed;
  transition: all 0.3s ease;
  box-sizing: border-box;
  display: block;
  height: 100%;
}

.gift-radio-button ::v-deep .el-radio-button__inner:hover {
  border-color: #409eff;
}

.gift-item {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.gift-image {
  width: 100%;
  aspect-ratio: 260 / 200;
  border-radius: 6px 6px 0 0;
  overflow: hidden;
  display: block;
  position: relative;
  min-height: 0;
}

.gift-image ::v-deep .el-image {
  width: 100%;
  height: 100%;
  display: block;
}

.gift-image ::v-deep .el-image__inner {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  display: block;
}

.gift-image ::v-deep img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  display: block;
}

.gift-name {
  margin: 12px;
  font-size: 14px;
  line-height: 1.4;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

.gift-radio-button ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #fff !important;
  color: #409eff !important;
  border: 2px solid #409eff !important;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* Submit Description */
.submit-description {
  font-size: 16px;
  line-height: 1.6;
  color: #606266;
}

/* Success Page */
.success-container {
  background-color: #fff;
  border-radius: 12px;
  padding: 30px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.success-image {
  width: 100%;
  max-width: 300px;
  height: auto;
  margin-bottom: 20px;
  border-radius: 8px;
}

.success-message {
  font-size: 16px;
  line-height: 1.6;
  color: #606266;
}

/* Button Group */
.button-group {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
  flex-wrap: wrap;
}

.action-button {
  min-width: 120px;
  height: 44px;
  font-size: 16px;
  border-radius: 6px;
  font-weight: 500;
}

/* Desktop Styles */
@media (min-width: 768px) {
  .app-container {
    max-width: 800px;
    padding: 20px;
  }

  .header-card {
    margin-bottom: 30px;
    padding: 20px;
  }

  .logo-col {
    margin-bottom: 20px;
  }

  .logo {
    width: 120px;
  }

  .page-title {
    font-size: 32px;
  }

  .form-item-card {
    padding: 24px;
    margin-bottom: 24px;
  }

  .satisfaction-radio-group {
    flex-direction: row;
    gap: 24px;
  }

  .button-group {
    justify-content: flex-end;
    margin-top: 30px;
  }

  .action-button {
    min-width: 140px;
  }

  .success-container {
    padding: 40px 30px;
  }

  .success-image {
    max-width: 400px;
  }
}

/* Large Desktop Styles */
@media (min-width: 1200px) {
  .app-container {
    max-width: 1000px;
    padding: 30px;
  }

  .header-card {
    padding: 30px;
  }

  .page-title {
    font-size: 36px;
  }

  .form-item-card {
    padding: 30px;
  }
}

/* Mobile Optimizations */
@media (max-width: 767px) {
  .app-container {
    padding: 8px;
  }

  .header-card {
    margin-bottom: 16px;
    padding: 16px;
  }

  .logo-col {
    margin-bottom: 12px;
  }

  .page-title {
    font-size: 20px;
  }

  .logo {
    width: 80px;
  }

  .form-item-card {
    padding: 16px;
    margin-bottom: 16px;
  }

  .form-item-card ::v-deep .el-form-item__label {
    font-size: 15px !important;
  }

  .form-item-card ::v-deep .el-form-item__content {
    font-size: 15px !important;
  }

  .full-width-select ::v-deep .el-input__inner {
    height: 48px;
    font-size: 16px; /* Prevent zoom on iOS */
  }

  .form-item-card ::v-deep .el-input__inner {
    height: 48px;
    font-size: 16px; /* Prevent zoom on iOS */
  }

  .button-group {
    flex-direction: column;
    width: 100%;
    margin-top: 20px;
  }

  .action-button {
    width: 100%;
    min-width: 100%;
    height: 48px;
  }

  .gift-image {
    aspect-ratio: 260 / 200;
    min-height: 0;
  }

  .gift-image ::v-deep .el-image {
    width: 100%;
    height: 100%;
    display: block;
  }

  .gift-image ::v-deep .el-image__inner {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
  }

  .gift-image ::v-deep img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    display: block;
  }

  .gift-name {
    font-size: 13px;
    margin: 10px;
  }

  .success-container {
    padding: 20px 16px;
  }

  .success-image {
    max-width: 100%;
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  .app-container {
    padding: 5px;
  }

  .header-card {
    padding: 12px;
  }

  .logo-col {
    margin-bottom: 10px;
  }

  .page-title {
    font-size: 18px;
  }

  .logo {
    width: 70px;
  }

  .form-item-card {
    padding: 12px;
  }

  .gift-image {
    aspect-ratio: 260 / 200;
    min-height: 0;
  }

  .gift-image ::v-deep .el-image {
    width: 100%;
    height: 100%;
    display: block;
  }

  .gift-image ::v-deep .el-image__inner {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
  }

  .gift-image ::v-deep img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    display: block;
  }
}

/* Touch-friendly improvements for mobile */
@media (hover: none) and (pointer: coarse) {
  .action-button {
    min-height: 48px;
  }

  .satisfaction-radio-group ::v-deep .el-radio {
    min-height: 44px;
    display: flex;
    align-items: center;
  }

  .gift-radio-button {
    min-height: 44px;
  }
}

/* Print Styles */
@media print {
  .app-container {
    max-width: 100%;
    padding: 0;
  }

  .button-group {
    display: none;
  }
}
</style>
